// import TopHeader from "../../components/TopHeader"
// import '../../../assets/_prestataire.scss'
import { Link, useNavigate } from "react-router-dom";

const Confirmation = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-grey d-flex align-items-center">
        <div className="container">
          <div className="col-lg-6 mx-auto bg-white text-center p-40 ">
            {props?.isCompleted ? (
              <img src="/images/checkGreen.svg" alt="check icon" />
            ) : (
              <img
                src="/images/notCompleted.svg"
                alt="not completed icon"
                className="w-25"
              />
            )}
            <h3 className="mt-32">{props?.title} </h3>
            {props?.text && <p className="body mt-16">{props?.text}</p>}
            {props?.btnText ? (
              <button
                className="btn twyny-cta-primary w-100 mt-32"
                onClick={props.clickPrimary}
              >
                {props?.btnText}
              </button>
            ) : (
              ""
            )}
            <div className="mt-24">
              <Link to={props?.ctaLink} className="link-primary mt-24">
                {props?.ctatext}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Confirmation;
